export type CheckTokenParams = {
  token: string
}

export type ConfirmEmailParams = {
  code: string
}

const endpoints = {
  login: 'Api/auth',
  signup: 'api/v2/users',
  confirmEmail: ({ code }: ConfirmEmailParams) => {
    return `api/v2/confirmation/${code}`
  },
  changePassword: 'Api/auth.php',
  restorePasswordByEmail: 'Api/auth.php',
  checkToken: ({ token }: CheckTokenParams) => {
    return `api/v2/auth/token/${token}/status`
  },
}

export default endpoints
